import * as yup from 'yup';
import { treasuryWithdrawFormFields } from '../../fields/formFields/treasuryWithdraw';
import { amountSchema } from '../common/amountSchema';

const requiredText = (label: string) =>
  yup.string().trim().max(255, `${label} must be at most 255 characters`).required(`${label} is required`);

export const treasuryWithdrawSchema = yup.object({
  [treasuryWithdrawFormFields.amount]: amountSchema,
  [treasuryWithdrawFormFields.beneficiaryName]: requiredText('Beneficiary name'),
  [treasuryWithdrawFormFields.beneficiaryIban]: requiredText('IBAN'),
  [treasuryWithdrawFormFields.beneficiarySwiftCode]: requiredText('SWIFT code'),
  [treasuryWithdrawFormFields.reason]: requiredText('Reason'),
});
